import { all } from "redux-saga/effects";
import authenticationSagas from "redux/authentication/authenticationSaga";
import changePasswordSaga from "redux/changePassword/changePasswordSaga";
import patientListSaga from "redux/patients/patientList/patientListSaga";
import downloadPatientCSVSaga from "redux/patients/downloadPatientCSV/downloadPatientCSVSaga";
import deletePatientSaga from "redux/patients/deletePatient/deletePatientSaga";
import consultationListSaga from "redux/consultations/consultationList/consultationListSaga";
import consultationDetailsSaga from "redux/consultations/consultationDetails/consultationDetailsSaga";
import downloadConsultationCSVSaga from "redux/consultations/downloadConsultationCSV/downloadConsultationCSVSaga";
import getConsentStatementSaga from "redux/consentStatement/getConsentStatement/getConsentStatementSaga";
import postConsentStatementSaga from "redux/consentStatement/postConsentStatement/postConsentStatementSaga";
import settingInformationSaga from "redux/setting/general/generalSettingSaga";
import defaultSettingSaga from "redux/setting/default/defaultSettingSaga";
import verifyPhoneNumberSaga from "redux/setting/verifyPhoneNumber/verifyPhoneNumberSaga";
import patientRegistrationSaga from "redux/setting/patientRegistration/patientRegistrationSaga";
import verifyOTPSaga from "redux/setting/verifyOTP/verifyOTPSaga";
import voiceCallSaga from "redux/setting/voiceCall/voiceCallSaga";
import dashboardInfoSaga from "redux/dashboard/dashboardInfo/dashboardInfoSaga";
import subscribeSuperCitySaga from "redux/patients/subscribeSuperCity/subscribeSuperCitySaga";
import activitiesListFilterSagas from "redux/messagemanagement/activitiesfilterlist/activitiesFilterListSaga";
import classListFilterSagas from "redux/messagemanagement/classfilterlist/classFilterListSaga";
import studentListSagas from "redux/messagemanagement/getstudentlist/getStudentListSaga";
import temperatureListFilterSagas from "redux/messagemanagement/temperaturefilterlist/temperatureFilterListSaga";
import messageHistoryListSagas from "redux/messagemanagement/messagehistory/messageHistoryListSagas";
import messageHistoryDetailSagas from "redux/messagemanagement/messagehistorydetail/messageHistoryDetailSagas";
import attendanceListFilterSagas from "redux/messagemanagement/attendancefilterlist/attendanceFilterListSaga";
import sendMessageSagas from "redux/messagemanagement/sendmessage/sendMessageSagas";
import searchConditionSagas from "redux/messagemanagement/searchCondition/searchConditionSaga";
import readHistoryListSaga from "redux/messagemanagement/readHistory/readHistoryListSaga";
import pushNotificationSaga from "redux/messagemanagement/pushNotification/pushNotificationSagas";
import updateMessageDeliverySaga from "redux/messagemanagement/updateMessage/updateMessageSaga";
import deleteMessageDeliverySaga from "redux/messagemanagement/deleteMessage/deleteMessageSaga";
import resendMessageSaga from "redux/messagemanagement/resendMessage/resendMessageSaga";
import forgotPasswordSagas from "redux/forgotpassword/forgotpasswordSaga";
import resetPasswordSagas from "redux/resetpassword/resetpasswordSaga";
import verifyResetPasswordTokenSagas from "redux/verifyResetPasswordToken/verifyResetPasswordTokenSaga";

export default function* startForman() {
  yield all([
    ...authenticationSagas,
    ...changePasswordSaga,
    ...patientListSaga,
    ...downloadPatientCSVSaga,
    ...deletePatientSaga,
    ...consultationListSaga,
    ...consultationDetailsSaga,
    ...downloadConsultationCSVSaga,
    ...getConsentStatementSaga,
    ...postConsentStatementSaga,
    ...settingInformationSaga,
    ...defaultSettingSaga,
    ...verifyPhoneNumberSaga,
    ...patientRegistrationSaga,
    ...verifyOTPSaga,
    ...voiceCallSaga,
    ...dashboardInfoSaga,
    ...subscribeSuperCitySaga,
    ...activitiesListFilterSagas,
    ...classListFilterSagas,
    ...studentListSagas,
    ...temperatureListFilterSagas,
    ...messageHistoryListSagas,
    ...messageHistoryDetailSagas,
    ...attendanceListFilterSagas,
    ...sendMessageSagas,
    ...searchConditionSagas,
    ...readHistoryListSaga,
    ...pushNotificationSaga,
    ...updateMessageDeliverySaga,
    ...deleteMessageDeliverySaga,
    ...resendMessageSaga,
    ...forgotPasswordSagas,
    ...resetPasswordSagas,
    ...verifyResetPasswordTokenSagas,
  ]);
}
